import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { date } from '@vette/common-utils';

import { SessionInLocalStorage } from '../types';

export const useSessionHandlers = (
  sessionData: SessionInLocalStorage,
  clearSessionData: () => void
) => {
  const router = useRouter();

  useEffect(() => {
    if (sessionData && sessionData.url !== router.asPath) {
      router.replace(sessionData.url);
    }
  }, [router, sessionData]);

  useEffect(() => {
    if (sessionData?.expiresAt) {
      const timeout = setTimeout(() => {
        clearSessionData();
      }, sessionData.expiresAt - date.utcTimestamp());

      return () => clearTimeout(timeout);
    }
  }, [sessionData?.expiresAt, clearSessionData]);
};
